import AIModelBadge from "../../../components/ai/AIModelBadge";
import SingleValueSelector from "../../../components/common/editors/SingleValueSelector";

export default function AIModelSelector({ value, onChange }) {

    const modelNames = [
        'claude-3-7-sonnet-20250219',
        'claude-sonnet-4-20250514',
        'o4-mini',
        'gpt-4o',
        'gpt-4.1',
        // 'o3',
        'gemini-2.0-flash',
        // 'gemini-2.0-flash-preview-image-generation',
        'gemini-2.5-flash-preview-05-20',
        // 'gemini-2.5-pro-exp-03-25',
        'gemini-2.5-pro-preview-06-05',
        'gemini-2.5-flash-lite-preview-06-17'
    ];

    const models = modelNames.map(modelName => ({
        value: modelName,
        label: <span className="no-wrap">
            <AIModelBadge model={modelName} showName={true} />
            {modelName.match(/^gemini-2\.5-pro/) ? <span className="badge-pill badge-danger align-middle zoom-75">slow</span> : null}
        </span>
    }));

    return <SingleValueSelector placeholder='Default AI model' className={'flex-grow-1 zoom-75'} value={value} onChange={onChange} options={models} />
}
